export default {"src":"/_next/static/media/affirm-logo-long.98d66569.svg","height":28,"width":90,"blurWidth":0,"blurHeight":0};